import { RecreationStringLabels } from '../../../../util/Strings';
import RecreationTable from './RecreationTable';
import ModuleHeader from '../../../common-components/ModuleHeader';
import { useSelector } from 'react-redux';
import { useState } from 'react';

function Recreation() {
  const data = useSelector((state) => state.recreation.recreationData);
  const isVisitCompleted = useSelector(
    (state) => state.visits.selectedVisitIsCompleted
  );

  const [showOrderModal, setShowOrderModal] = useState(false);

  return (
    <div className="events-list-container">
      <ModuleHeader
        heading={RecreationStringLabels.roam}
        buttons={[
          {
            label: "Update Order",
            onClick: () => setShowOrderModal(true),
            show: data && data.length > 0 && !isVisitCompleted,
          },
        ]}
      />
      <div className="events-list-content">
        <RecreationTable
          showOrderModal={showOrderModal}
          setShowOrderModal={setShowOrderModal}
        />
      </div>
    </div>
  );
}

export default Recreation;